/**
 * Spine (kernel-native: the kernel is the system of record; no coreBOS module yet).
 * Categories of data subjects (employees, customers, minors…).
 * Hand-written (ADR-029 §4); links to other spines are graph edges, see src/spines.ts.
 */
export const dataSubjectCategoryDescriptor = {
    slug: 'cmp_data_subject_category',
    kind: 'document',
    label: { singular: 'Categoria di interessati', plural: 'Categorie di interessati' },
    table: 'compliance_data_subject_category',
    idStrategy: 'sha256',
    fields: [
        { name: 'name', type: 'text', label: 'Nome', required: true },
        { name: 'description', type: 'text', label: 'Descrizione' },
        { name: 'vulnerable', type: 'boolean', label: 'Interessati vulnerabili' },
    ],
    relations: [],
    behaviors: { audit: true, softDelete: true, tenantScoped: true },
    ui: { mode: 'generated', icon: 'TeamOutlined', navGroup: 'Organizzazione' },
};
